/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './screenmaker.module.css';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, Tag, message, Upload, Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiFilter, CiSearch } from 'react-icons/ci';
import FormModal from '../../components/Modal/FormModal';
import { CiImport, CiExport } from "react-icons/ci";
import Header from '../../components/Header/header';
import * as Action from '../../store/slices/screenmaker/screenmaker'
import { connect } from 'react-redux';
import TransactionModal from './TransactionModal';
import ApproveModal from './ApproveModal';
import { useNavigate } from 'react-router-dom';

interface Api {
    getScreenMaker: (params: { page: number; size: number }) => void;
    ScreenMaker_Red: any;
}

interface DataSource {
    key: string;
    fileId: string;
    fileName: string;
    Status: string;
}

const ScreenMakerTable: React.FC<Api> = ({ getScreenMaker, ScreenMaker_Red }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(9);
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['fileId', 'fileName', 'Status']);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [open, setOpen] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('');
    const [tableData, setTableData] = useState<DataSource[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [searchText, setSearchText] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [transactionModalVisible, setTransactionModalVisible] = useState(false);
    const [selectedFileId, setSelectedFileId] = useState<number | null>(null);
    const [approveModalVisible, setApproveModalVisible] = useState(false);
    const [approveFileId, setApproveFileId] = useState<number | null>(null);
    const [refreshKey, setRefreshKey] = useState(0);




    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchText);
        }, 500);

        return () => clearTimeout(timer);
    }, [searchText]);




    console.log(ScreenMaker_Red, 'screenmaker')

    useEffect(() => {
        fetchScreenMakers(currentPage, pageSize);
    }, [currentPage, pageSize, debouncedSearch, refreshKey]);

    const fetchScreenMakers = (page: number, size: number) => {
        setLoadingText(true);
        const token = localStorage.getItem('loginToken');
        fetch(`${process.env.REACT_APP_API_URL}/campaign/get-unapproved-files/${page - 1}/${size}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(res => res.json())
            .then(res => {
                if (Array.isArray(res)) {
                    setTableData(res.map((item: any) => ({
                        key: item.fileId,
                        fileId: item.fileId,
                        fileName: item.fileName || '-',
                        Status: 'Pending',
                    })));
                    setTotal(res.length);
                } else {
                    setTableData([]);
                    setTotal(0);
                }
            })
            .catch(() => {
                setTableData([]);
                setTotal(0);
            })
            .finally(() => setLoadingText(false));
    };

    const onSearch = (value: string) => setSearchText(value.toLowerCase());

    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };




    const Addhandle = () => {
        setShowForm(true);
    };

    const Backhandle = () => {
        setShowForm(false);
    };

    const handleOpen = () => {
        setModalText('Are you sure you want to delete this record?');
        setOpen(true);
    }

    const handleRowClick = (record: DataSource) => {
        setSelectedFileId(Number(record.fileId));
        setTransactionModalVisible(true);
    };





    const actionMenu = (
        <Space direction="vertical" className={style.actions}>
            <div className={style.dropdownItem}>Edit</div>
            <div className={style.dropdownItem} onClick={handleOpen}>Delete</div>
        </Space>
    );

    const allColumns = [
        {
            title: 'File ID',
            dataIndex: 'fileId',
            key: 'fileId',
            width: 150,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.fileId || !b.fileId) return 0;
                return a.fileId.localeCompare(b.fileId);
            },
        },
        {
            title: 'File Name',
            dataIndex: 'fileName',
            key: 'fileName',
            width: 300,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.fileName || !b.fileName) return 0;
                return a.fileName.localeCompare(b.fileName);
            },
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => {
                if (!a.Status || !b.Status) return 0;
                return a.Status.localeCompare(b.Status);
            },
            render: (Status: string) => {
                const color = Status === "Active" ? "cyan" : Status === "Pending" ? "yellow" : "red";
                return (
                    <Tag style={{ marginInlineEnd: 0 }} color={color}>
                        {Status.toUpperCase()}
                    </Tag>
                )
            },
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            render: (_: any, record: DataSource) => (
                <Button type="primary" size="small" onClick={(e) => {
                    e.stopPropagation();
                    setApproveFileId(Number(record.fileId));
                    setApproveModalVisible(true);
                }}>
                    Approve
                </Button>
            ),
        },
    ];

    const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

    const filteredData = tableData.filter((item) =>
        Object.values(item).some((val) =>
            val.toString().toLowerCase().includes(searchText)
        )
    );

    const items = [
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('fileId')}
                    value={'fileId'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'fileId')}
                >
                    File ID
                </Checkbox>
            ),
            key: '1',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('fileName')}
                    value={'fileName'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'fileName')}
                >
                    File Name
                </Checkbox>
            ),
            key: '2',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Status')}
                    value={'Status'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Status')}
                >
                    Status
                </Checkbox>
            ),
            key: '3',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Date')}
                    value={'Date'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Date')}
                >
                    Date
                </Checkbox>
            ),
            key: '6',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('CreatedBy')}
                    value={'CreatedBy'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'CreatedBy')}
                >
                    Created By
                </Checkbox>
            ),
            key: '7',
        },
    ];

    const handleExport = async () => {
        setButtonLoading(true);
        message.loading('Fetching all data for export...', 0);
        
        try {
            await getScreenMaker({ page: 0, size: 100000 });
            
            setTimeout(() => {
                const allData = ScreenMaker_Red?.data?.[0]?.res?.data?.content || [];
                
                if (allData.length === 0) {
                    message.destroy();
                    message.warning("No data to export!");
                    setButtonLoading(false);
                    return;
                }
                
                const mappedData = allData.map((item: any) => ({
                    ReferenceID: item.screenCode,
                    ScreenName: item.screenName || "-",
                    Type: item.screenType || "-",
                    Module: item.module || "-",
                    Date: item.createdDate
                        ? new Date(item.createdDate).toLocaleDateString("en-GB")
                        : "-",
                    CreatedBy: item.createdBy || "-",
                    Status: "Active"
                }));
                
                const csvContent = [
                    ['Screen ID', 'Screen Name', 'Type', 'Module', 'Date', 'Created By', 'Status'],
                    ...mappedData.map((item: any) => [
                        item.ReferenceID || '',
                        item.ScreenName || '',
                        item.Type || '',
                        item.Module || '',
                        item.Date || '',
                        item.CreatedBy || '',
                        item.Status || ''
                    ])
                ].map(row => row.join(',')).join('\n');
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `all_screenmaker_data_${new Date().toISOString().split('T')[0]}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                message.destroy();
                message.success(`All ${allData.length} screen makers exported successfully!`);
                setButtonLoading(false);
                
                fetchScreenMakers(currentPage, pageSize);
            }, 1000);
            
        } catch (error) {
            message.destroy();
            message.error("Failed to export data. Please try again.");
            setButtonLoading(false);
        }
    };

    return (
        <div className={style.sroll}>
            <Header />
            <FormModal modalTitle={modalText} Subtitle={modalText} open={open} setOpen={setOpen} onOk={() => console.log('Form submitted!')} onCancel={() => console.log('Modal cancelled')} />
            <TransactionModal 
                visible={transactionModalVisible} 
                fileId={selectedFileId} 
                onClose={() => setTransactionModalVisible(false)} 
            />
            <ApproveModal
                visible={approveModalVisible}
                fileId={approveFileId}
                onClose={() => setApproveModalVisible(false)}
                onSuccess={() => {
                        setApproveModalVisible(false);
                        setRefreshKey(prev => prev + 1);
                    }}
            />
            {showForm ? (
                ""
            ) : (
                <>
                    <div className={style.Route}>
                        <h5>Uploaded Files</h5>
                        <div className={style.btns}>
                            {/* <Button
                                type="primary"
                                onClick={handleExport}
                                className={style.createBtn2}
                            >
                                <CiExport />
                                Data Export
                            </Button> */}
                        </div>
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    onChange={(e) => onSearch(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                        </Space>
                        <Table
                            loading={loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData}
                            pagination={false}
                            rowSelection={{ type: 'checkbox' }}
                            size="small"
                            onRow={(record) => ({
                                onClick: () => handleRowClick(record),
                                style: { cursor: 'pointer' }
                            })}
                        />
                        <Pagination
                            align="end"
                            showTotal={(total) => `Total ${total} items`}
                            current={currentPage}
                            total={total}
                            pageSize={pageSize}
                            pageSizeOptions={[9, 18, 36, 72]}
                            showSizeChanger
                            onChange={(page, newSize) => {
                                setCurrentPage(page);
                                if (newSize !== pageSize) {
                                    setPageSize(newSize);
                                    setCurrentPage(1); 
                                }
                            }}
                        />
                    </div>
                </>
            )
            }
        </div >
    );
};

function mapStateToProps(state: any) {
    return {
        ScreenMaker_Red: state.ScreenMaker_Red
    }
}

export default connect(mapStateToProps, Action)(ScreenMakerTable)
